
// noinspection ES6UnusedImports

import {h, type JSX} from '@stencil/core';



import {
  GuidedQuickLinkDetails,
} from '../models/quick-link';


import {typeRegistry} from './component-registry';
import {makeLogger} from '../../../logger/logger';

import {
  AbstractGuidedUiElement,
} from '../models/Guided.schema';


import {GuidedV2Skeleton as _skeleton} from './skeleton/ui';
import {GuidedV2Divider as _divider} from './divider/ui';
import {GuidedV2FooterBanner as _banner} from './footer-banner/ui';
import {GuidedV2GenaiBanner as _getaiBanner} from './genai-banner/ui';
import {GuidedV2ResultListFactory as _resultList} from './result-list-section/ui';
import {GuidedV2GuidedUiPnaSectionFactory as _pna} from './pna-quick-link/ui';
import {GuidedV2KeywordSuggestions as _keywordSuggestions} from './keyword-suggestion/ui';
import {GuidedV2PromotedSuggestions as _promotedSuggestions} from './promoted-suggestions/ui';
import {GuidedV2PopularQueries as _popularQueries} from './popular-queries/ui';
import {GuidedV2FeaturedQuickLinks as _featuredQuickLinks} from './features-quick-links/ui';
import {GuidedV2HistoryOfSearches as _historyOfSearches} from './history/ui';
import {GuidedV2FeaturedCtaBanners as _featuredCtaBanners} from './featured-cta-banners/ui';
import {GuidedV2NoResultMessage as _noResultMessage} from './no-result-message/ui';
import {GuidedV2NoLinksMessageFactory as _noLinksMessage} from './no-links-message/ui';

import type {GuidedV2FactoryState} from '../models/ui';


const {
  //info,
  debug,
  //warn,
  err
} = makeLogger({pathToCurrentFile: 'components/guided2/subcomponents/ui-components.tsx'});

/**
 * Main helper method fo Guided Search V2 to render its elements
 * @param data
 * @param state
 * @constructor
 */
export function GuidedUiElementFactory<LinkType extends GuidedQuickLinkDetails = GuidedQuickLinkDetails>(
  data: AbstractGuidedUiElement,
  state: GuidedV2FactoryState<LinkType>,
): JSX.Element {

    // @ts-ignore
    const type = data.type;
    const factory = typeRegistry[type];
    if (factory) {
      debug('Instantiating component', type, data);
      return factory(data, state);
    } else{
      err('No such component', type, data);
      return <div data-err="No such component" data-type={type} data-item={data}></div>;
    }
}
